
interface DefaultAvatarProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

const DefaultAvatar = ({ className = "", size = 'md' }: DefaultAvatarProps) => {
  const sizeClasses = {
    sm: 'w-12 h-12',
    md: 'w-24 h-24', 
    lg: 'w-32 h-32',
    xl: 'w-48 h-48'
  };

  return (
    <div className={`${sizeClasses[size]} ${className} relative overflow-hidden rounded-full`}>
      <svg 
        viewBox="0 0 400 400" 
        className="w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Happy gradient background */}
        <defs>
          <linearGradient id="happyGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#fbbf24" />
            <stop offset="50%" stopColor="#f59e0b" />
            <stop offset="100%" stopColor="#d97706" />
          </linearGradient>
        </defs>
        
        {/* Background */}
        <rect width="400" height="400" fill="url(#happyGradient)" />
        
        {/* Silhouette */}
        <path 
          d="M200 50 C240 50 280 80 280 130 C280 140 280 150 275 160 L275 180 C275 190 275 200 270 210 L270 230 C270 240 265 250 260 260 L260 280 C260 290 255 300 250 310 L250 330 C250 340 245 350 235 355 L165 355 C155 350 150 340 150 330 L150 310 C145 300 140 290 140 280 L140 260 C135 250 130 240 130 230 L130 210 C125 200 125 190 125 180 L125 160 C120 150 120 140 120 130 C120 80 160 50 200 50 Z"
          fill="#4f46e5"
          opacity="0.8"
        />
        
        {/* Face area */}
        <ellipse 
          cx="200" 
          cy="120" 
          rx="50" 
          ry="60" 
          fill="#6366f1"
          opacity="0.9"
        />
        
        {/* Body/torso */}
        <path 
          d="M160 200 C160 190 170 180 185 180 L215 180 C230 180 240 190 240 200 L240 280 C240 320 220 340 200 340 C180 340 160 320 160 280 Z"
          fill="#6366f1"
          opacity="0.9"
        />
        
        {/* Shoulders */}
        <ellipse 
          cx="145" 
          cy="220" 
          rx="25" 
          ry="35" 
          fill="#6366f1"
          opacity="0.7"
        />
        <ellipse 
          cx="255" 
          cy="220" 
          rx="25" 
          ry="35" 
          fill="#6366f1"
          opacity="0.7"
        />
      </svg>
    </div>
  );
};

export default DefaultAvatar;
